import KalshiIcon from "~/assets/platforms/kalshi.svg";
import LimitlessIcon from "~/assets/platforms/limitless.svg";
import LimitlessMark from "~/assets/platforms/marks/limitless.jpg";
import OpinionMark from "~/assets/platforms/marks/opinion.png";
import PolymarketMark from "~/assets/platforms/marks/polymarket.svg";
import PredictMark from "~/assets/platforms/marks/predict.png";
import OpinionIcon from "~/assets/platforms/opinion.svg";
import PolymarketIcon from "~/assets/platforms/polymarket.svg";
import PredictFun from "~/assets/platforms/predict_fun.svg";
import { PlatformEnum } from "~/types/platform";

export const logoByPlatform: Record<PlatformEnum, string> = {
  [PlatformEnum.KALSHI]: KalshiIcon,
  [PlatformEnum.POLYMARKET]: PolymarketIcon,
  [PlatformEnum.PREDICTION_FUN]: PredictFun,
  [PlatformEnum.LIMITLESS]: LimitlessIcon,
  [PlatformEnum.OPINION]: OpinionIcon,
};

export const nameByPlatform: Record<PlatformEnum, string> = {
  [PlatformEnum.KALSHI]: "Kalshi",
  [PlatformEnum.POLYMARKET]: "Polymarket",
  [PlatformEnum.PREDICTION_FUN]: "Predict",
  [PlatformEnum.LIMITLESS]: "Limitless",
  [PlatformEnum.OPINION]: "Opinion",
};

export const brandColorByPlatform: Record<
  PlatformEnum,
  { background: string; color: "ink" | "white" }
> = {
  [PlatformEnum.POLYMARKET]: { background: "#2E5CFF", color: "white" },
  [PlatformEnum.KALSHI]: { background: "#00DD94", color: "ink" },
  [PlatformEnum.PREDICTION_FUN]: { background: "#6C5CE7", color: "white" },
  [PlatformEnum.LIMITLESS]: { background: "#C3FF01", color: "ink" },
  [PlatformEnum.OPINION]: { background: "#FF6B2C", color: "white" },
};

export const markByPlatform: Record<PlatformEnum, string> = {
  [PlatformEnum.KALSHI]: KalshiIcon,
  [PlatformEnum.POLYMARKET]: PolymarketMark,
  [PlatformEnum.PREDICTION_FUN]: PredictMark,
  [PlatformEnum.LIMITLESS]: LimitlessMark,
  [PlatformEnum.OPINION]: OpinionMark,
};
